/**
 * 予約フォーム
 */

document.addEventListener('DOMContentLoaded', function() {
  if (document.body.classList.contains('page-booking-form')) {
    const urlParams = new URLSearchParams(window.location.search);
    const rsvPlan = urlParams.get('rsv_plan');
    // セレクトボックスの値を設定
    if (rsvPlan) {
      const selectBox = document.getElementById('booking-option-plan');
      selectBox.value = rsvPlan;
    }
  }
});

